/**
 * @generated SignedSource<<a2421ea831bfcb49e125702f3bd05309>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarContact_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_item" | "PdpSharedRequestHold_item">;
  readonly " $fragmentType": "PdpRespSidebarContact_item";
};
export type PdpRespSidebarContact_item$key = {
  readonly " $data"?: PdpRespSidebarContact_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarContact_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarContact_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRequestHold_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "222e787c008c0418077eadeb1256389c";

export default node;
